module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.href) ? _c('a', {
    attrs: {
      "title": _vm.title,
      "href": _vm.href
    }
  }, [(_vm.icon) ? _c('i', {
    staticClass: "fa",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.iconSrc) ? _c('img', {
    staticStyle: {
      "width": "17px",
      "padding-right": "2px",
      "margin-top": "-2px"
    },
    attrs: {
      "src": _vm.iconSrc
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.to) ? _c('router-link', {
    attrs: {
      "to": _vm.to,
      "tag": "a",
      "title": _vm.title
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.icon
  })]) : _vm._e(), _vm._v(" "), (!_vm.to && !_vm.href) ? _c('a', _vm._g({
    attrs: {
      "title": _vm.title
    }
  }, _vm.$listeners), [_c('i', {
    staticClass: "fa",
    class: _vm.icon
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e085b89","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusables/ActionsMenuItem.vue
// module id = 1691
// module chunks = 1